import Axios, { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';

// 兼容 error code 不为1的情况
type ErrorCode = 1 | 5;

export interface ReturnSuccessResponse<T> {
  error: 0;
  data: T;
}
export interface ReturnErrorResponse {
  error: ErrorCode;
  message: string;
}
interface HttpReturnSuccessResponse {
  err_no: 0;
  err_tips: '成功';
}

export interface HttpReturnErrorResponse {
  err_no: number;
  err_tips: string;
  data: Record<string, unknown>;
}

type RequestBaseFunc = (
  axiosInstance: AxiosInstance,
) => <Req, Res>(
  req: AxiosRequestConfig<Req>,
) => AxiosPromise<ReturnResponse<Res>>;

type RequestSimpleFunc = (
  axiosInstance: AxiosInstance,
) => <Req, Res>(req: AxiosRequestConfig<Req>) => AxiosPromise<Res>;

type RequestHttpFunc = (
  axiosInstance: AxiosInstance,
) => <Req, Res>(
  req: AxiosRequestConfig<Req>,
) => AxiosPromise<HttpReturnResponse<Res>>;

export type ReturnResponse<T> = ReturnSuccessResponse<T> | ReturnErrorResponse;

export type HttpReturnResponse<T> =
  | (HttpReturnSuccessResponse & T)
  | HttpReturnErrorResponse;

const defaultAxiosRequestConfig: AxiosRequestConfig = {
  timeout: 7000,
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
};

let axios: AxiosInstance | undefined;

export const initAxios = (param: AxiosRequestConfig): AxiosInstance => {
  if (!axios) {
    axios = Axios.create({
      ...defaultAxiosRequestConfig,
      ...param,
    });
  } else {
    // eslint-disable-next-line no-console
    console.log('axios已经初始化过了');
  }
  return axios;
};

export const createBaseRequest: RequestBaseFunc = axiosInstance => req =>
  axiosInstance(req);

export const createBaseRequestWithOutReturnResponse: RequestSimpleFunc =
  axiosInstance => req =>
    axiosInstance(req);

export const createBaseRequestHttpCase: RequestHttpFunc =
  axiosInstance => req =>
    axiosInstance(req);
